module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('main-layout', {
    attrs: {
      "action": _vm.action,
      "subject": _vm.subject
    }
  }, [_c('div', {
    attrs: {
      "slot": "side-menu"
    },
    slot: "side-menu"
  }, [_c('side-menu', {
    attrs: {
      "user": _vm.me
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('app-header', {
    attrs: {
      "me": _vm.me,
      "activities": _vm.activities,
      "scheduledPosts": _vm.scheduledMessages,
      "companies": _vm.companies,
      "breadCrumbs": []
    },
    on: {
      "onNewSocialPost": _vm.onNewSocialPost,
      "onSearch": function($event) {
        return _vm.onSearch($event)
      },
      "onCollapseMenu": function($event) {
        return _vm.onCollapseMenu()
      },
      "onLogout": function($event) {
        return _vm.onLogout()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('app-footer')], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "alerts"
    },
    slot: "alerts"
  }, [_c('staff-alerts')], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "toast"
    },
    slot: "toast"
  }, [_c('toast'), _vm._v(" "), _c('notification')], 1)]), _vm._v(" "), _c('modal-container')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-755d5768","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/app/MainApp.vue
// module id = 3342
// module chunks = 3